<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Mutfak Düzenle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn
          class="mr-3"
          type="button"
          variant="danger"
          to="/Settings/Kitchens"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth > 380">Mutfaklar</span>
        </b-btn>

        <b-btn class="mr-3" type="button" variant="info" @click="Refresh()" :size="ButtonSize">
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth > 360">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Kitchen).length === 0">Hata!</b-alert>

    <b-alert
      show
      variant="info"
      v-if="Object.keys(Kitchen).length > 0"
    >Düzenlenen Mutfak: {{ KitchenOldName }}</b-alert>

    <form @submit.prevent="SaveKitchen" v-if="Object.keys(Kitchen).length > 0">
      <b-form-group class="formgroup" label="Mutfak Adı">
        <b-form-input type="text" v-model="Kitchen.Name" @keypress.enter.prevent="SaveKitchen"></b-form-input>
      </b-form-group>

      <b-form-group class="formgroup" label="Durumu">
        <b-form-checkbox-group
          v-model="Kitchen.Status"
          :options="[{value: 1, text: (Kitchen.Status) ? 'Aktif' : 'Pasif'}]"
          switches
          :state="!!Kitchen.Status"
        ></b-form-checkbox-group>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Kaydet</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      KitchenOldName: "",
      Kitchen: {}
    };
  },
  async created() {
    await this.Refresh();
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    ParamID() {
      return this.$route.params.ID;
    },
    KitchenGUI() {
      return Object.filterKey(
        this.Kitchen,
        x => ["Name", "Status"].indexOf(x) !== -1
      );
    }
  },
  methods: {
    async Refresh() {
      if (!this.StoreData.Kitchens) return;
      if (!this.StoreData.Kitchens[this.ParamID]) return;

      let _Kitchen = Object.assign({}, this.StoreData.Kitchens[this.ParamID]);

      delete _Kitchen.Products;

      await this.$set(this, "KitchenOldName", _Kitchen.Name);
      await this.$set(this, "Kitchen", _Kitchen);

      await this.$nextTick();
      await this.$forceUpdate();
    },
    async SaveKitchen() {
      await this.$store.dispatch("AddLoading", "SaveKitchen");

      await Services.Nozich.Send(
        "SaveKitchen",
        {
          ID: this.ParamID,
          Kitchen: this.Kitchen
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SaveKitchen");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/Kitchens");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
